import { storageKey } from './utils.service';

/** Identifies this browser across sign-ins so the session screens can tell
 *  "the same PC signing in again" from "a different machine". It is random,
 *  carries no personal data, and survives sign-out on purpose. */
const DEVICE_ID_KEY = 'deviceId';

function newDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'd-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
}

export function getDeviceId(): string {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = newDeviceId();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return '';
  }
}

/** Signs the browser out locally: removes everything the app stored except
 *  the device id. */
export function clearAuthStorage(): void {
  const deviceId = localStorage.getItem(DEVICE_ID_KEY);
  localStorage.clear();
  if (deviceId) localStorage.setItem(DEVICE_ID_KEY, deviceId);
}

/** Keys written at sign-in. Kept here so every way of signing in (password,
 *  code, recovery code) stores the same things. */
export function storeSignIn(res: any, email: string, keepMeLogin: boolean): void {
  localStorage.setItem(storageKey.accessToken, res.access_token);
  localStorage.setItem(storageKey.refreshToken, res.refresh_token);
  localStorage.setItem(storageKey.isAdmin, String(res.isAdmin));
  localStorage.setItem(storageKey.isMSUser, String(res.isMSUser));
  localStorage.setItem(storageKey.isActive, String(res.isActive));
  localStorage.setItem(storageKey.email, email);
  localStorage.setItem(storageKey.userId, String(res.userId));
  localStorage.setItem(storageKey.roleId, String(res.roleId));
  localStorage.setItem(storageKey.keepMeLogin, String(keepMeLogin));
}

/** Replaces the tokens after a security change re-issued them (the old ones
 *  stop working on the server). */
export function storeReissuedTokens(res: any): void {
  if (!res?.access_token) return;
  localStorage.setItem(storageKey.accessToken, res.access_token);
  if (res.refresh_token) localStorage.setItem(storageKey.refreshToken, res.refresh_token);
  if (res.email) localStorage.setItem(storageKey.email, res.email);
}
